import React from 'react';

import Icon from '../../../shared/items/static/icon'
import DropDownSelect from '../../../shared/items/contols/dropDownSelect'
import SortCarsDropdownMenu from './sortCarsDropdownMenu'
import { getSortCarsTypeTitle } from './static.sortCarsTypes'
import { sortDirections } from './static.sortDirections'

import styles from './sortCarsDropdown.module.scss'

const SortCarsDropdown = props => {
  const { onHandleChangeStore, filterItems } = props

  return (
    <div className={styles.sortCars}>
      <div className={styles.container_direction}>
        <div
          className={filterItems.orderDesc === sortDirections.asc ? styles.container_direction_asc_active : styles.container_direction_asc}
          onClick={onHandleChangeStore.bind(this, 'orderDesc', sortDirections.asc)}
        >
          <Icon name="direction-asc" />
        </div>
        <div
          className={filterItems.orderDesc === sortDirections.desc ? styles.container_direction_desc_active : styles.container_direction_desc}
          onClick={onHandleChangeStore.bind(this, 'orderDesc', sortDirections.desc)}
        >
          <Icon name="direction-desc" />
        </div>
      </div>
      <DropDownSelect
        buttonTitle={getSortCarsTypeTitle(filterItems.orderBy)}
        content={<SortCarsDropdownMenu handleChooseType={onHandleChangeStore.bind(this, 'orderBy')} />}
      />
    </div>
  )
}

export default React.memo(SortCarsDropdown)
